module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('button', {
    staticClass: "cart-btn button",
    on: {
      "click": _vm.addToCart
    }
  }, [_vm._v(" Buy Now")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-126d5681"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/ProductCTAActions.vue
// module id = 250
// module chunks = 0